document.addEventListener('DOMContentLoaded', function () {
  const selector = document.querySelector('vehicle-model-selector');
  const imageContainer = document.querySelector('.configurator__image');

  if (!selector || !imageContainer) {
    return;
  }

  function hideAllImages() {
    const images = imageContainer.querySelectorAll('img');
    images.forEach((img) => {
      img.style.display = 'none';
    });
  }

  function showDefaultImages() {
    const defaultImages = imageContainer.querySelectorAll('[data-vehicle="default"]');
    defaultImages.forEach((img) => {
      img.style.display = 'block';
    });
  }

  function showImages(selectedValue) {
    hideAllImages();
    if (!selectedValue) {
      showDefaultImages();
      return;
    }
    const matchingImages = imageContainer.querySelectorAll(`[data-vehicle="${selectedValue}"]`);

    if (matchingImages.length === 0) {
      showDefaultImages();
    } else {
      matchingImages.forEach((img) => {
        img.style.display = 'block';
      });
    }
  }

  selector.addEventListener('vehicleSelected', function (event) {
    showImages(event.detail && event.detail.value);
  });

  // Initial setup
  // console.log('Initial setup, showing default images');
  const trigger = selector.querySelector('.disclosure__button');
  const triggerSpan = trigger && trigger.querySelector('span[data-label]');
  const selectedOption = selector.querySelector('.disclosure__link[aria-selected="true"]');
  let initialValue = selectedOption && selectedOption.dataset.value;
  if (!initialValue && triggerSpan) {
    const triggerText = (triggerSpan.textContent || '').trim();
    const placeholder = (triggerSpan.getAttribute('data-label') || '').trim();
    if (triggerText && triggerText !== placeholder) {
      const match = Array.from(selector.querySelectorAll('.disclosure__link')).find(
        (btn) => (btn.textContent || '').trim() === triggerText
      );
      initialValue = match && match.dataset.value;
    }
  }
  if (initialValue) {
    showImages(initialValue);
  } else {
    showDefaultImages();
  }
});
